import { useEffect, useState } from "react";
import { Box, Image, Heading } from "@chakra-ui/react";

import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { SEO } from "../components/SEO";
import StructuredData from "../components/SEO/StructuredData";

import { wisp } from "../lib/wispEvent";

import { Button } from "../components/ui/button";
import { PaginationControl } from "../components/PaginationControl";

export const Events = () => {
  const [newsBlog, setNewsBlog] = useState<any[]>([]);

  const [currentPage, setCurrentPage] = useState<number>(1);

  const [pagination, setPagination] = useState<any>();

  useEffect(() => {
    const getNewsBlog = async () => {
      const result = await wisp.getPosts({ limit: 3, page: currentPage });

      setPagination(result.pagination);

      setNewsBlog(result.posts);
    };

    getNewsBlog();
  }, [currentPage]);

  return (
    <Box>
      <SEO 
        title="Events | Udobong Ntia"
        description="Stay updated with Udobong Ntia's latest events, speaking engagements, and appearances in the oil and energy sector."
        canonicalUrl="https://udobongntia.com/events"
        keywords={['Udobong Ntia Events', 'Energy Sector Events', 'Oil and Gas Events', 'ExxonMobil Events', 'Industry Conferences', 'NNPC']}
      />
      <StructuredData 
        type="Organization" 
        data={{
          name: 'Udobong Ntia Events',
          description: 'Events, speaking engagements, and appearances by Udobong Ntia in the oil and energy sector.'
        }}
      />
      <Header />

      <Box
        maxW={"790px"}
        minH={"100vh"}
        borderLeftWidth={"1px"}
        borderRightWidth={"1px"}
        borderColor={"#E7E8E9"}
        justifySelf={"center"}
        px={{ base: "16px", lg: "95px" }}
        pt={{ base: "140px", lg: "191px" }}
        pb="41px"
      >
        <Box>
          <Heading
            fontSize={{ base: "28px", lg: "38px" }}
            fontWeight={600}
            color={"#101720"}
            fontFamily={"BricolageGrotesque"}
          >
            Events
          </Heading>
        </Box>

        <Box>
          <Box mb="44px">
            {newsBlog.map((blogPost) => (
              <Box
                key={blogPost.id}
                mt="40px"
                borderRadius={"32px"}
                borderWidth={"1.5px"}
                borderColor={"#E7E8E9"}
                p="20px"
                bg="#FAFAFA"
              >
                <Image
                  src={blogPost.image}
                  alt={`${blogPost.title} - Udobong Ntia event`}
                  objectFit={"cover"}
                  w="100%"
                  borderRadius={"15px"}
                />

                <Heading
                  my="23px"
                  fontSize={"33px"}
                  fontWeight={600}
                  color={"black"}
                  lineHeight={"140%"}
                >
                  {blogPost.title}
                </Heading>

                <Button
                  bg="#E7E8E9"
                  borderWidth={0}
                  color={"#101720"}
                  onClick={() => window.open(blogPost.description, "_blank")}
                >
                  See Details
                </Button>
              </Box>
            ))}
          </Box>

          <PaginationControl
            currentPage={currentPage}
            totalPages={pagination?.totalPages}
            onPageChange={setCurrentPage}
          />

          <Footer />
        </Box>
      </Box>
    </Box>
  );
};
